import axios from "axios";
import endPoints from "../../../../config/endPoints";


export const getAllReportsApi = async(deptId, reqBody) => {
  return await axios.post(`${endPoints.receiptTracking}/${deptId}/search`, reqBody);  
};

export const findReportsApi = async(reqBody) => {
  return await axios.post(`${endPoints.reports}/report`, reqBody);
};
